<div class="dialogWrapper cardModal">
    <i class="icon fal fa-xmark" (click)="cancel()"></i>
    <div class="cardContent">
        <h2>{{ 'changePassword.label' | translate }}</h2>
        <form [formGroup]="changePasswordForm">
            <div class="inputGroup">
                <label for="currentPassword">{{ 'changePassword.currentPassword' | translate }}</label>
                <div class="inputWrapper">
                    <app-form-error [parentForm]="changePasswordForm" [controlPath]="'currentPassword'" />
                    <app-password-input [showHints]="false" [id]="'currentPassword'" formControlName="currentPassword" />
                </div>
            </div>

            <div class="inputGroup">
                <label for="newPassword">{{ 'changePassword.newPassword' | translate }}</label>
                <div class="inputWrapper">
                    <app-form-error [parentForm]="changePasswordForm" [controlPath]="'newPassword'" />
                    <app-password-input [id]="'newPassword'" formControlName="newPassword" />
                </div>
            </div>

            <div class="inputGroup">
                <label for="repeatNewPassword">{{ 'changePassword.repeatNewPassword' | translate }}</label>
                <div class="inputWrapper confirmPasswordContainer">
                    <app-form-error [parentForm]="changePasswordForm" [controlPath]="'repeatNewPassword'" />
                    <app-password-input [showHints]="false" [id]="'repeatNewPassword'" formControlName="repeatNewPassword" />
                </div>
            </div>
        </form>
        <div class="buttonArea">
            <button type="submit" class="button primary" (click)="changePassword()">{{ 'changePassword.label' | translate }}</button>
            <button type="button" class="button" (click)="cancel()">{{ 'generalKeywords.cancel' | translate }}</button>
        </div>
    </div>
</div>
